export default __webpack_public_path__ + "static/media/warrior.d26433a2.svg";